export const PaymentFrequency: {
  WEEKLY: string;
  BIWEEKLY: string;
} = {
  WEEKLY: "weekly",
  BIWEEKLY: "biweekly",
};
